// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"c50e0f4c","277":"26f8c6a8","453":"021f48d9","482":"c9bb9fc8","487":"a971c299","573":"67b6a2ca","690":"ae4a22fb","727":"60b2ad73","868":"c04ffea8","940":"3b548c34","964":"070d1410"}[chunkId] + ".chunk.js";
};